// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_Y5s","cls2":"CreateSocialItemModal-cls2__Q5 CreateSocialItemModal-cls1_Y5s"};